import moment from "moment";
import React from "react";

const StatusBadge = ({ cancelledAt, updatedAt, status }) => {
  return (
    <div>
      {status === "revoked" ? (
        <span className="badge badge-pill bg-danger">Revocada</span>
      ) : status === "cancelled" ? (
        <span className="badge badge-pill bg-danger">
          Cancelada el{" "}
          {moment(cancelledAt !== null ? cancelledAt : updatedAt)
            .utc()
            .local()
            .format("DD MMM YYYY HH:mm")}
        </span>
      ) : status === "active" ? (
        <span className="badge badge-pill bg-success">Activa</span>
      ) : status === "completed" ? (
        <span className="badge badge-pill bg-success">Completada</span>
      ) : status === "pending" ? (
        <span className="badge badge-pull bg-warning text-dark">Pendiente</span>
      ) : status === "failed" ? (
        <span className="badge badge-pull bg-danger text-white">Fallido</span>
      ) : (
        <span className="badge badge-pull bg-secondary text-capitalize">
          {status}
        </span>
      )}
    </div>
  );
};
export default StatusBadge;
